const project = {
  slug: "sales-invoice-inventory",
  title: "Sales Invoice & Inventory Management",
  oneLiner: "Automated invoicing, stock alerts, and sales-trend analytics.",
  role: ["Full-stack Developer"],
  category: "Web Development",
  clientOrOrg: "Singhe Suppliers",
  timeframe: { start: "2024-09", status: "In Progress" },
  domain: ["ERP", "Operations"],
  tech: ["Laravel", "MySQL", "jQuery", "Bootstrap"],
  links: { live: "https://singhesuppliers.com" },
  gallery: [
    {
      src: "/assets/singhesuppliers/singhesuppliers-overview.png",
      alt: "singhesuppliers-1"
    },
  ],
  impact: [
    "Reduced manual errors by ~90% through workflow automation.",
    "Faster item lookup via NIC/ID and stock alerting."
  ],
  responsibilities: [
    "End-to-end CRUD modules and reporting",
    "Auth, role permissions, and data validations"
  ],
  features: [
    "Invoices, inventory, supplier & customer ledgers",
    "Stock thresholds, alerts, and trend dashboards"
  ],
  architecture: [
    "Laravel MVC + MySQL",
    "Server-side rendering with jQuery/Bootstrap components"
  ],
  seo: {
    title: "Sales & Inventory - Full-stack Laravel Case Study",
    description:
      "Built an invoicing and inventory system with alerts and analytics in Laravel/MySQL; reduced manual errors by ~90%."
  },
  cover: "/assets/singhesuppliers/singhesuppliers-featured.png"
};

export default project;
